import { ContentBlock, ContentState, Modifier, SelectionState } from "draft-js";
import { MentionSelection } from "../types/types";

export const appendMentions = (content: ContentState, mentions: MentionSelection[], block: ContentBlock) => {
    mentions.forEach(({ anchorOffset, focusOffset, mention }) => {
        if (block.getEntityAt(anchorOffset)) {
            return;
        }

        const entityType = "mention"; // see: getTypeByTrigger in draft-js-mention-plugin
        content = content.createEntity(entityType, "SEGMENTED", {
            mention,
        });
        const mentionKey = content.getLastCreatedEntityKey();
        const mentionSelection: SelectionState = new SelectionState({
            anchorKey: block.getKey(),
            anchorOffset,
            focusKey: block.getKey(),
            focusOffset,
        });
        content = Modifier.applyEntity(content, mentionSelection, mentionKey);
    });
    return content;
};
